import {
	Route as ReactDomRoute,
	RouteProps as ReactDOMRouteProps,
	Redirect,
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';
import { useCart } from '../hooks/cart';

interface RouteProps extends ReactDOMRouteProps {
	isPrivate?: boolean;
	component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
	isPrivate = false,
	component: Component,
	...rest
}) => {
	const { user } = useAuth();
	const { cart } = useCart();

	return (
		<ReactDomRoute
			{...rest}
			render={({ location }) => {
				return isPrivate === !!user ?
					location.pathname.includes('/client') && cart && cart.cliente.id ?
						<>
							<Redirect
								to={{
									pathname: isPrivate ? '/' : '/products',
									state: { from: location },
								}}
							/>
							<Component />
						</>
						: location.pathname.includes('/product') && !cart.cliente?.id ?
							<>
								<Redirect
									to={{
										pathname: isPrivate ? '/' : '/client',
										state: { from: location },
									}}
								/>
								<Component />
							</>
						:	<Component />
				 : (
					<Redirect
						to={{
							pathname: isPrivate 
								? '/'
								: cart && cart.cliente && cart.cliente.id
									? '/products'
									: '/client',
							state: { from: location },
						}}
					/>
				);
			}}
		/>
	);
};

export default Route;